import { createAction } from 'redux-actions';

export const SetFormError = createAction('SET_FORM_ERROR');
export const ClearFormError = createAction('CLEAR_FORM_ERROR');
